import { Component } from 'react';
import styled, { css } from 'styled-components';
import { fontSize } from '../../../../../common/css/setting/variable';

interface IProps {
  isCurrent: boolean;
  name: string;
  url?: string;
  onclick?: () => void;
  dataClParams: string;
  isFontSizeLarge: boolean;
  isSpaced: boolean;
}

const InputCommonStyle = css<{ $isCurrent: boolean; $isFontSizeLarge: boolean }>`
  display: block;
  font-size: ${fontSize.px12};
  font-weight: bold;

  /* hrefが空の場合でもpointerにする */
  cursor: pointer;

  /* 現在のタブ */
  ${({ $isCurrent }) =>
    $isCurrent
      ? css`
          color: ${props => props.theme.news.palette.text_base_common};

          &:hover {
            text-decoration: none;
          }
        `
      : css`
          color: ${props => props.theme.news.palette.link_pc};
        `}

  /* テキスト大きめに表示したい時 */
  ${({ $isFontSizeLarge }) =>
    $isFontSizeLarge
      ? css`
          font-size: ${fontSize.px14};
        `
      : ''}
`;

const Link = styled.a<{ $isCurrent: IProps['isCurrent']; $isFontSizeLarge: IProps['isFontSizeLarge'] }>`
  ${InputCommonStyle}
`;

const Button = styled.button<{ $isCurrent: IProps['isCurrent']; $isFontSizeLarge: IProps['isFontSizeLarge'] }>`
  ${InputCommonStyle}
  /**
   * NEWS-1072にて本SCをa -> buttonタグへの移行を実施
   * src/public/template/pc/common/components/css/base/_base_common.css にてbuttonのoutlineは無効化されているため、
   * ユーザーエージェントスタイルシートの値にリセットする
  */
  &:focus {
    outline: revert;
  }
`;

const Item = styled.li<{ $isSpaced: IProps['isSpaced'] }>`
  /* 子要素の左側に罫線をつける */
  & + & {
    position: relative;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      width: 1px;
      height: 12px;
      content: '';
      background-color: ${props => props.theme.news.palette.bor_lv2_pc};
      transform: translateY(-50%);
    }
  }

  /* 余白の設定 */
  ${({ $isSpaced }) =>
    $isSpaced
      ? css`
          /* 左右の余白を広めに表示したい時 */
          padding-right: 10px;
          padding-left: 10px;
        `
      : css`
          /* 通常 */
          & + & {
            padding-left: 6px;
          }
          &:not(:last-child) {
            padding-right: 5px;
          }
        `}
`;

export default class TabItemText extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <Item $isSpaced={this.props.isSpaced}>
        {this.props.url ? (
          <Link
            href={this.props.url}
            data-cl-params={this.props.dataClParams}
            onClick={() => {
              if (this.props.onclick) {
                this.props.onclick();
              }
            }}
            $isCurrent={this.props.isCurrent}
            $isFontSizeLarge={this.props.isFontSizeLarge}
          >
            {this.props.name}
          </Link>
        ) : (
          // URLの指定がない場合はbuttonで描画する
          <Button
            data-cl-params={this.props.dataClParams}
            onClick={() => {
              if (this.props.onclick) {
                this.props.onclick();
              }
            }}
            $isCurrent={this.props.isCurrent}
            $isFontSizeLarge={this.props.isFontSizeLarge}
          >
            {this.props.name}
          </Button>
        )}
      </Item>
    );
  }
}
